import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const IconSvg = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_2061_28084)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.39584 11.6349L7.40007 2.30776L5.63228 4.07615C5.51898 4.18942 5.36534 4.25305 5.20514 4.25305C5.04493 4.25305 4.89129 4.18942 4.77799 4.07615C4.66473 3.96286 4.6011 3.80921 4.6011 3.64901C4.6011 3.48881 4.66473 3.33516 4.77799 3.22186L6.71797 1.28128C6.88629 1.11285 7.08615 0.979239 7.30613 0.88808C7.52611 0.79692 7.76189 0.75 8.00001 0.75C8.23813 0.75 8.47392 0.79692 8.69389 0.88808C8.91387 0.979239 9.11373 1.11285 9.28205 1.28128L11.222 3.22368C11.3353 3.33697 11.3989 3.49062 11.3989 3.65082C11.3989 3.81102 11.3353 3.96467 11.222 4.07797C11.1087 4.19123 10.9551 4.25486 10.7949 4.25486C10.6347 4.25486 10.481 4.19123 10.3677 4.07797L8.60841 2.31803L8.60418 11.6349C8.60418 11.7951 8.54052 11.9488 8.42722 12.0621C8.31392 12.1754 8.16025 12.239 8.00001 12.239C7.83978 12.239 7.6861 12.1754 7.5728 12.0621C7.4595 11.9488 7.39584 11.7951 7.39584 11.6349ZM14.0417 13.4378V11.0211C14.0417 10.8608 14.1053 10.7072 14.2186 10.5939C14.3319 10.4806 14.4856 10.4169 14.6458 10.4169C14.8061 10.4169 14.9597 10.4806 15.073 10.5939C15.1863 10.7072 15.25 10.8608 15.25 11.0211V13.4378C15.25 13.9185 15.059 14.3795 14.7191 14.7194C14.3792 15.0593 13.9182 15.2503 13.4375 15.2503H2.5625C2.0818 15.2503 1.62078 15.0593 1.28087 14.7194C0.940959 14.3795 0.75 13.9185 0.75 13.4378V11.0211C0.75 10.8608 0.813653 10.7072 0.926956 10.5939C1.04026 10.4806 1.19393 10.4169 1.35417 10.4169C1.5144 10.4169 1.66807 10.4806 1.78138 10.5939C1.89468 10.7072 1.95833 10.8608 1.95833 11.0211V13.4378C1.95833 13.598 2.02199 13.7517 2.13529 13.865C2.24859 13.9783 2.40227 14.0419 2.5625 14.0419H13.4375C13.5977 14.0419 13.7514 13.9783 13.8647 13.865C13.978 13.7517 14.0417 13.598 14.0417 13.4378Z"
        fill="#151718"
      />
    </g>
    <defs>
      <clipPath id="clip0_2061_28084">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const UploadIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={IconSvg} {...props} />
);

export default UploadIcon;
